import parser from 'accept-language-parser';

import { DEFAULT_COUNTRY, DEFAULT_LANG } from '../constants/Constants';

export const isShortActiveUrl = (url = '') => {
    const regexp = new RegExp(`^/(ml|l|b|new/b)-`);
    return regexp.test(url);
};

export const pushPath = (sourceRoutes = [], routs) => {
    sourceRoutes.forEach((r) => {
        if (Array.isArray(r.path)) {
            r.path.forEach((path) => {
                routs.push({ ...r, path: path });
            });
        } else {
            routs.push(r);
        }
    });
    return routs;
};
export const getLangAndCountryFromUrl = (url = '', userLangCookie, acceptLanguage = '', cloudflareIpCountry = '') => {
    let lang = DEFAULT_LANG;
    let country = DEFAULT_COUNTRY;

    const langURI = getLanguage(url);

    if (langURI?.length === 2) {
        lang = langURI;
    } else if (checkPrefix('_', langURI)) {
        const arr = langURI.split('_');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else if (checkPrefix('-', langURI)) {
        const arr = langURI.split('-');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else if (userLangCookie?.length === 5) {
        const arr = userLangCookie.split('-');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else {
        country = cloudflareIpCountry || DEFAULT_COUNTRY;

        let parseArray = parser.parse(acceptLanguage);
        if (Array.isArray(parseArray) && parseArray.length > 0) {
            let actualLangInfo = parseArray.at(0);
            lang = actualLangInfo.code || DEFAULT_LANG;
        }
    }

    return { lang: lang, country: country };
};

const checkPrefix = (prefix, lang) => {
    return lang?.length === 5 && lang?.includes(prefix);
};
const getLanguage = (referrer) => {
    if (!referrer) return null;

    if (referrer === '/alipay') {
        return 'zh';
    }

    // Remove "/api" if it's present at the beginning of the referrer
    const cleanedReferrer = referrer.startsWith('/api') ? referrer.slice(4) : referrer;

    const language = cleanedReferrer.split('/')[1];
    return language || null;
};
